import React from "react";
import { Form, Slider } from "antd";

const FilterRange = ({ filter }) => {
  const marks = {
    [filter.min]: filter.min,
    [filter.max]: filter.max,
  };
  return (
    <Form.Item name={filter.facet}>
      <Slider
        marks={marks}
        range
        defaultValue={[filter.min, filter.max]}
        max={filter.max}
        min={filter.min}
        disabled={false}
      />
    </Form.Item>
  );
};

export default FilterRange;
